import { Outlet } from 'react-router-dom';

import { ProtectedRoute } from '@occc-app/App/routes/ProtectedRoute';
import { Feature } from '@occc/utils-access-control';

export const TriggeredMessageEditLayout = () => {
  return (
    <ProtectedRoute feature={Feature.TRIGGERED_MESSAGES_EDIT}>
      <Outlet />
    </ProtectedRoute>
  );
};
